module.exports = __webpack_public_path__ + "static/img/M3.b57c9bee.png";